export default {
    install: (app, options) => {

        app.config.globalProperties.$auth = () => {
            const user = {
                check: () => {
                    return Number.isInteger(_.get(app.config.globalProperties.$page.props, "auth.user.id"));
                },
                user: () => _.get(app.config.globalProperties.$page.props, "auth.user"),
            }
            return user;
        }

        app.provide('auth', options);
    }
}
